import { Text } from "@overmap-ai/blocks"
import type { Form, Stored } from "@overmap-ai/common"
import {
	type ColumnDef,
	getCoreRowModel,
	getSortedRowModel,
	type TableOptions,
	useReactTable,
} from "@tanstack/react-table"
import { useMemo } from "react"

import { formatTimestampDate } from "../../../utils/date"
import { ColumnSortButton, ColumnSortIcon } from "../components"

export const useFormSettingsTableColumns = () => {
	return useMemo<ColumnDef<Stored<Form>>[]>(
		() => [
			{
				id: "name",
				accessorFn: (form) => form.name,
				meta: {
					plainHeader: "Name",
				},
				header({ column }) {
					return (
						<ColumnSortButton column={column} variant="ghost" size="sm" accentColor="base">
							Name
							<ColumnSortIcon sortDirection={column.getIsSorted()} />
						</ColumnSortButton>
					)
				},
				cell({ getValue }) {
					return <Text>{getValue<string>()}</Text>
				},
			},
			{
				id: "submitted_at",
				sortingFn: "datetime",
				accessorFn: (originalRow) => originalRow.submitted_at,
				meta: {
					plainHeader: "Submitted at",
				},
				header({ column }) {
					return (
						<ColumnSortButton column={column} variant="ghost" size="sm" accentColor="base">
							Submitted at
							<ColumnSortIcon sortDirection={column.getIsSorted()} />
						</ColumnSortButton>
					)
				},
				cell({ getValue }) {
					return <Text accentColor="base">{formatTimestampDate(getValue<string>())}</Text>
				},
			},
		],
		[],
	)
}

export const useFormSettingsTable = (args: Omit<TableOptions<Stored<Form>>, "getCoreRowModel">) => {
	return useReactTable<Stored<Form>>({
		...args,
		getCoreRowModel: getCoreRowModel(),
		getSortedRowModel: getSortedRowModel(),
	})
}
